var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerAppsScalable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "papp_filter0_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "papp_filter1_f"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.38,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "papp_paint0_linear",
    x1: 71,
    y1: 96.0002,
    x2: 15,
    y2: -40.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#742774"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB35A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "papp_paint1_linear",
    x1: 32,
    y1: 0.0002436,
    x2: 78,
    y2: 96.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E48CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D467B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "papp_paint2_linear",
    x1: 62,
    y1: 29.0002,
    x2: 76,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E48CC7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "papp_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "papp_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "papp_clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(0 0.00012207)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#papp_clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#papp_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#papp_clip2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "papp_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 1,
    width: 97,
    height: 94
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45715 44.049C-0.522237 46.3111 -0.522238 49.6889 1.45715 51.951L36.9897 92.5596C38.5833 94.381 41.4167 94.381 43.0103 92.5596L46.8367 88.1866L51.0504 92.7833C52.6358 94.5128 55.3623 94.5128 56.9476 92.7833L94.2825 52.0543C96.3853 49.7604 96.3853 46.2396 94.2825 43.9457L56.9476 3.21667C55.3623 1.4872 52.6358 1.4872 51.0504 3.21667L46.8367 7.81341L43.0103 3.44035C41.4167 1.61904 38.5833 1.61904 36.9897 3.44035L1.45715 44.049Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#papp_mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 96L-2 48L40 0L82 48L40 96Z",
    fill: "url(#papp_paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#papp_filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.999 2L97.999 50L53.999 98L34.4767 76.7029C33.0748 75.1736 33.0748 72.8264 34.4767 71.2971L51.5214 52.7029C52.9232 51.1736 52.9232 48.8264 51.5214 47.2971L34.4767 28.7029C33.0748 27.1736 33.0748 24.8264 34.4767 23.2971L53.999 2Z",
    fill: "black",
    fillOpacity: 0.32
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#papp_filter1_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.999 0.380127L97.999 48.3801L53.999 96.3801L34.4767 75.083C33.0748 73.5537 33.0748 71.2065 34.4767 69.6772L51.5214 51.083C52.9232 49.5537 52.9232 47.2065 51.5214 45.6772L34.4767 27.083C33.0748 25.5537 33.0748 23.2065 34.4767 21.6772L53.999 0.380127Z",
    fill: "black",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.999 0L97.999 48L53.999 96L34.4767 74.7029C33.0748 73.1736 33.0748 70.8264 34.4767 69.2971L51.5214 50.7029C52.9232 49.1736 52.9232 46.8264 51.5214 45.2971L34.4767 26.7029C33.0748 25.1736 33.0748 22.8264 34.4767 21.2971L53.999 0Z",
    fill: "url(#papp_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0514 27.2167C74.6367 25.4872 77.3633 25.4872 78.9486 27.2167L98 48L78.9486 68.7833C77.3633 70.5128 74.6367 70.5128 73.0514 68.7833L57.7165 52.0543C55.6137 49.7604 55.6137 46.2396 57.7165 43.9457L73.0514 27.2167Z",
    fill: "url(#papp_paint2_linear)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerAppsScalable);
export default __webpack_public_path__ + "static/media/PowerApps_scalable.560875aee901f68f46f6ba7547a38d03.svg";
export { ForwardRef as ReactComponent };